import axios from 'axios'
import { isDebug } from '../utils/env'
import { signOut, getAuthHeaders } from 'bxl-auth'

export const fifthUrl = isDebug()
  ? 'https://5thave-dev.bieyangapp.com'
  : 'https://5thave-prod.bieyangapp.com'

export const papyrusUserLookUpUrl = isDebug()
  ? 'https://papyrus-dev.bybieyang.com/#/userlookup/'
  : 'https://papyrus.bybieyang.com/#/userlookup/'

const fifthaveClient = axios.create({
  baseURL: fifthUrl,
  // withCredentials: true,
  headers: {
    'X-BXL-User-Agent': 'BXL Curators Portal'
  },
})

fifthaveClient.interceptors.request.use(
  (config: any) => {
    if (config.method === 'get') {
      // fix axios issue: https://github.com/axios/axios/issues/86
      config.data = {}
    }
    config.headers = {
        ...config.headers,
        ...getAuthHeaders()
    }
    return config
  },
  (error: any) => {
    return error
  }
)

// 添加响应拦截器
fifthaveClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error?.response?.status === 401) {
      signOut()
      window.location.replace('#/login')
    }
    return Promise.reject(error)
  }
)

export default fifthaveClient
